import { Navigate } from "react-router-dom";

// Legacy admin login route — now redirects to the unified /login (admin mode).
export default function AdminLogin() {
  return <Navigate to="/login?mode=admin" replace />;
}
